import script from "./AccountUserMgmt.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountUserMgmt.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__